import { useState, useEffect } from "react";
import { Navigate, useParams, NavLink, useLocation } from "react-router-dom";
import { CollectionsResourceTiles } from "../../lib/collectiondata";

export default function CollectionPage() {
  const { collectionSlug } = useParams();
  const collection = CollectionsResourceTiles.find((tile) => tile.slug === collectionSlug);
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 100, behavior: "smooth" });
  }, [pathname]);

  if (!collection) {
    return <Navigate to="/app/collections" replace />;
  };

  return (
    <main className="all-resources-page page bg-white">
      <div className="p-5 space-y-3">
         <NavLink
            to="/app/collections"
            className="inline-flex items-center text-sm font-semibold token-link-primary"
            >
            ← Back to Collections
        </NavLink>
        <h1 className="flex text-5xl font-semibold text-gray-800 portrait:text-3xl lg:text-5xl md:text-5xl sm:text-3xl">
                    {collection.title}
        </h1>
        </div>
      <div className="w-full h-[calc(100vh-100px)] relative">
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
            <span className="loader"></span>
          </div>
        )}
        <iframe
          title={collection.title}
          className="airtable-embed"
          src={collection.url}
          width="100%"
          height="100%"
          style={{ background: "transparent", border: "1px solid var(--color-border-subtle)" }}
          onLoad={() => setLoading(false)}
        />
      </div>
    </main>
  );
}
